import { IAsidePanelTab } from '../../types';

export interface IAsidePanelHOCProps {
    activeTabIndex?: number;
    children?: any;
    className?: string;
    tabs?: ReadonlyArray<IAsidePanelTab>;
    title?: string;
}

export enum EAsidePanelViewType {
    BOARD = 'BOARD',
    CARD = 'CARD',
    FEEDBACK = 'FEEDBACK',
    CARD_PREVIEW = 'CARD PREVIEW',
    CARD_TEMPLATE = 'CARD TEMPLATE',
    CARD_TEMPLATES = 'CARD TEMPLATES',
    FILTER = 'FILTER',
    LIST = 'LIST',
    MULTI_LIST = 'MULTI LIST',
    MULTI_CARD = 'MULTI CARD',
    MY_WORK = 'MY WORK',
    RECURRING = 'RECURRING',
    RELATED = 'RELATED',
}
